{
  "tagline": "Wo Autoren schreiben",
  "trash": "Papierkorb"
}